import * as React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { setNavigator } from './navigator'
import { useCompanySelectionStore } from '@/modules/shared/stores/companySelectionStore'

/**
 * Montuje się w drzewie routera. Przepisuje wybraną firmę z adresu do zustanda
 * i rejestruje modułowy nawigator dla kodu spoza Reacta.
 *
 * Wcześniej wysyłał też `APP_LOCATION_CHANGE` do reduxa - reducery, które go
 * słuchały, już nie istnieją.
 */
export function RouterBridge() {
  const location = useLocation()
  const navigate = useNavigate()

  React.useEffect(() => {
    setNavigator((to, options) => navigate(to, options))
    return () => setNavigator(null)
  }, [navigate])

  React.useEffect(() => {
    useCompanySelectionStore.getState().syncFromPath(location.pathname)
  }, [location.key, location.pathname, location.search, location.hash])

  return null
}
